/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DeleteSurveyVersionAsync$Plain$Params {

/**
 * surveyversion id
 */
  surveyVersionId: number;
}

export function deleteSurveyVersionAsync$Plain(http: HttpClient, rootUrl: string, params: DeleteSurveyVersionAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<number>> {
  const rb = new RequestBuilder(rootUrl, deleteSurveyVersionAsync$Plain.PATH, 'delete');
  if (params) {
    rb.path('surveyVersionId', params.surveyVersionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
    })
  );
}

deleteSurveyVersionAsync$Plain.PATH = '/api/SurveyVersion/{surveyVersionId}';
